//@flow

import React from "react";
import { Field } from "react-final-form";
import type { FieldRenderProps } from "react-final-form";
import { changeServiceFormInteraction } from "Commons/Utilities/GoogleTagManager";
import { Input } from "modules/ChangeServiceForm/components/shared/CommonComponents";
import { composeValidators } from "modules/ChangeServiceForm/misc/validations";
import { isMaxLength, isPhoneOrNotPresent } from "Commons/Utilities/validators";

const AreaCode = ({ stepName }: { stepName: string }) => {
  return (
    <Field name={"areaCode"} validate={composeValidators(isMaxLength(10), isPhoneOrNotPresent)}>
      {(props: FieldRenderProps) => {
        return (
          <Input
            fullWidth
            placeholder="Vorwahl"
            errorMessage={(props.meta.modified || props.meta.touched) && props.meta.error}
            error={(props.meta.modified || props.meta.touched) && props.meta.error}
            {...props.input}
            autoComplete="tel-area-code"
            onClick={() => changeServiceFormInteraction(stepName, "AREA_CODE")}
          />
        );
      }}
    </Field>
  );
};

export default AreaCode;
